import { render, staticRenderFns } from "./SithMesPrdKamChangeEdit.vue?vue&type=template&id=56d7baf6&"
import script from "./SithMesPrdKamChangeEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdKamChangeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports